import { MonthYearValue } from "../../../../../../utils/MonthYear/MonthYearValue";

export const priceMockData: MonthYearValue[] = [
    { value: 45, date: { month: 1, year: 2024 } },
    { value: 74, date: { month: 1, year: 2025 } },
    { value: 47, date: { month: 1, year: 2026 } },
    { value: 16, date: { month: 2, year: 2024 } },
    { value: 53, date: { month: 2, year: 2025 } },
    { value: 9, date: { month: 2, year: 2026 } },
    { value: 4, date: { month: 3, year: 2024 } },
    { value: 3, date: { month: 3, year: 2025 } },
    { value: 20, date: { month: 3, year: 2026 } },
    { value: 2, date: { month: 4, year: 2024 } },
    { value: 11, date: { month: 4, year: 2025 } },
    { value: 85, date: { month: 4, year: 2026 } },
    { value: 98, date: { month: 5, year: 2024 } },
    { value: 34, date: { month: 5, year: 2025 } },
    { value: 62, date: { month: 5, year: 2026 } },
    { value: 35, date: { month: 6, year: 2024 } },
    { value: 85, date: { month: 6, year: 2025 } },
    { value: 35, date: { month: 6, year: 2026 } },
    { value: 94, date: { month: 7, year: 2024 } },
    { value: 33, date: { month: 7, year: 2025 } },
    { value: 47, date: { month: 7, year: 2026 } },
    { value: 53, date: { month: 8, year: 2024 } },
    { value: 41, date: { month: 8, year: 2025 } },
    { value: 91, date: { month: 8, year: 2026 } },
    { value: 80, date: { month: 9, year: 2024 } },
    { value: 94, date: { month: 9, year: 2025 } },
    { value: 32, date: { month: 9, year: 2026 } },
    { value: 56, date: { month: 10, year: 2024 } },
    { value: 43, date: { month: 10, year: 2025 } },
    { value: 71, date: { month: 10, year: 2026 } },
    { value: 54, date: { month: 11, year: 2024 } },
    { value: 30, date: { month: 11, year: 2025 } },
    { value: 92, date: { month: 11, year: 2026 } },
    { value: 12, date: { month: 12, year: 2024 } },
    { value: 43, date: { month: 12, year: 2025 } },
    { value: 26, date: { month: 12, year: 2026 } },
];

export const quantityMockData: MonthYearValue[] = [
    { value: 0, date: { month: 1, year: 2024 } },
    { value: 20000, date: { month: 1, year: 2025 } },
    { value: 20000, date: { month: 1, year: 2026 } },
    { value: 0, date: { month: 2, year: 2024 } },
    { value: 20000, date: { month: 2, year: 2025 } },
    { value: 20000, date: { month: 2, year: 2026 } },
    { value: 0, date: { month: 3, year: 2024 } },
    { value: 20000, date: { month: 3, year: 2025 } },
    { value: 20000, date: { month: 3, year: 2026 } },
    { value: 20000, date: { month: 4, year: 2024 } },
    { value: 20000, date: { month: 4, year: 2025 } },
    { value: 20000, date: { month: 4, year: 2026 } },
    { value: 20000, date: { month: 5, year: 2024 } },
    { value: 20000, date: { month: 5, year: 2025 } },
    { value: 20000, date: { month: 5, year: 2026 } },
    { value: 20000, date: { month: 6, year: 2024 } },
    { value: 20000, date: { month: 6, year: 2025 } },
    { value: 20000, date: { month: 6, year: 2026 } },
    { value: 20000, date: { month: 7, year: 2024 } },
    { value: 20000, date: { month: 7, year: 2025 } },
    { value: 20000, date: { month: 7, year: 2026 } },
    { value: 20000, date: { month: 8, year: 2024 } },
    { value: 20000, date: { month: 8, year: 2025 } },
    { value: 20000, date: { month: 8, year: 2026 } },
    { value: 20000, date: { month: 9, year: 2024 } },
    { value: 20000, date: { month: 9, year: 2025 } },
    { value: 20000, date: { month: 9, year: 2026 } },
    { value: 20000, date: { month: 10, year: 2024 } },
    { value: 20000, date: { month: 10, year: 2025 } },
    { value: 20000, date: { month: 10, year: 2026 } },
    { value: 20000, date: { month: 11, year: 2024 } },
    { value: 20000, date: { month: 11, year: 2025 } },
    { value: 0, date: { month: 11, year: 2026 } },
    { value: 20000, date: { month: 12, year: 2024 } },
    { value: 20000, date: { month: 12, year: 2025 } },
    { value: 0, date: { month: 12, year: 2026 } },
];